import classnames from 'classnames'
import * as React from 'react'
import { connect } from 'react-redux'

import { LoanOffer } from 'embed/constants/models'

import { OfferBanner } from 'embed/components/OfferBanner'
import { recommendedTextNotShown } from 'embed/selectors'
import { coAppBadgeBreakpoint } from 'embed/constants'
import { MultiProductState } from 'embed/reducers'

const styles = require('embed/styles/results')

export interface FlagProps {
  bestOfferId?: string
  isCompact?: boolean
  isResultsView?: boolean
  offer: LoanOffer
  shouldDisplayTransunionDisclaimer: boolean
  shouldHideRecommendedText?: boolean
  viewportWidth?: number
  tooltipText?: string
}

const FlagContainer = ({
  bestOfferId,
  isCompact,
  isResultsView,
  offer,
  offer: { productSubType },
  shouldDisplayTransunionDisclaimer,
  shouldHideRecommendedText,
  tooltipText = offer.productSubTypeDisclaimer,
  viewportWidth,
}: FlagProps) => {
  const showCoapplicantBadge =
    offer.coApplicant &&
    (offer.uuid !== bestOfferId || (offer.uuid === bestOfferId && (viewportWidth || false) > coAppBadgeBreakpoint))

  const recommendedOffer = !shouldHideRecommendedText && offer.uuid === bestOfferId
  if (offer.preApproved || offer.preQualified) {
    return (
      <div className={classnames(styles.flagContainer, { [styles.isCompact]: isCompact })}>
        <OfferBanner
          bannerType={productSubType}
          headerText={offer.preApproved ? 'Pre-approved' : offer.preQualified ? 'Pre-qualified' : ''}
          isResultsView={isResultsView}
          personalized={offer.preApproved || offer.preQualified}
          recommendedOffer={recommendedOffer}
          shouldDisplayTransunionDisclaimer={shouldDisplayTransunionDisclaimer}
          showCoapplicantBadge={showCoapplicantBadge}
          tooltipText={tooltipText}
        />
      </div>
    )
  } else {
    return (
      <OfferBanner bannerType={productSubType} showCoapplicantBadge={showCoapplicantBadge} tooltipText={tooltipText} />
    )
  }
}

export const mapStateToProps = (state: MultiProductState) => ({
  shouldHideRecommendedText: recommendedTextNotShown(state),
})

export const Flag = connect(mapStateToProps)(FlagContainer)
